import React from 'react';
import { injectIntl } from 'react-intl';

const HAStatistics = props => {
  const { height, width, intl } = props;
  const host = process.env.MULTIPRO_URL;
  const url = `${host}/partner/ha-statistic`;
  const title = 'HA Statistics';
  const locale = intl?.locale || 'en';

  return (
    <iframe
      title={title}
      src={`${url}?l=${locale}`}
      style={{
        width: width || '100%',
        height: height || '100vh',
        border: 'none'
      }}
    />
  );
};

export default injectIntl(HAStatistics);
